export default __webpack_public_path__ + "static/media/account.e7acb61d.svg";